import { memo } from 'react'
import BrandingLogo from 'd2/components/BrandingLogo'
import useStyles from './styles'

const ShareAlbumBrandingLogo = memo(() => {
  const { classes } = useStyles()
  return (<BrandingLogo
    className={classes.logo}
    variant='DEFAULT'
  />)
})

ShareAlbumBrandingLogo.displayName = 'ShareAlbumBrandingLogo'

export default ShareAlbumBrandingLogo
